<template>
  <div class="mask">
    <img class="close" @click="cancel()"  src="static/images/close.png" />
    <div class="payitem">
      <div class="paytitle">
        <p class="payhead">Century Games</p>
      </div>
      <div id="dropin" ></div>
      <div class="loadimg">
        <img class="load" src="static/images/load.gif" />
      </div>
    </div>
  </div>
</template>

<script>
  import {getReservationOrder} from '@/api/index.js'
  import axios from 'axios';
  export default {
    name: 'wechat',
    props: ['payinfo'],
    data() {
       return {
          baseurl: process.env.API_BASEURL,
          provider_order_id: null
       }
    },
    created(){
      if (this.provider_order) {
        this.checkOrderStatus()
      }
      this.getPreOrder()
    },
    methods: {
      cancel(){
        this.$parent.cancelpay()
      },
      // 获取预订单
      async getPreOrder() {
        const res = await getReservationOrder(this.payinfo)
        if(res.data.code == 1){
          console.log(res);
          const str = window.decodeURIComponent(res.data.data.gateway_data.alipay_params)

          window.open('https://openapi.alipay.com/gateway.do?app_id=2021003173611913&biz_content=%7B%22out_trade_no%22%3A%222010053882%22%2C%22product_code%22%3A%22QUICK_WAP_PAY%22%2C%22subject%22%3A%22%5Cu68a6%5Cu5883%5Cu4fa6%5Cu63a2VIP%5Cu652f%5Cu4ed8%22%2C%22total_amount%22%3A%220.01%22%7D&charset=utf-8&method=alipay.trade.wap.pay&notify_url=https%3A//payment-cn-sandbox.ifunplus.cn/return/alipay2016&quit_url=https%3A//vip-sandbox.campfiregames.cn/game%3Ftype%3Dquit%26game_id%3D20125&return_url=https%3A//vip-sandbox.campfiregames.cn/game%3Fgame_id%3D20125&sign_type=RSA2&timestamp=2023-02-13%2012%3A37%3A14&version=1.0&sign=CT5TUiRT9cDYuHJH6UI9qD1HMNlOVhSDi5NVRdE0caHsnKMmC/nfibKmrvInVywUYPvEZhbqB8ja3U0wmkrML0rOGuSmxmldlbqFKTJLv8lUtBrGjNMv8Z6PQ%2BP%2BVpDOGMqBy3LAzpMP%2BIq31DdcUe37//PVRv91fZh7jBrs2THgneTvlul6O0dkmiSxn3KNGJ0Q4djBSk5LFD34CMJ8R4MeQttKDjguKrjHfN/HEOzd77T1PKLpwbDS/AgVznBm65EhiGM7i2aXa9kcnXmABwLjOIBS3cUIHS/YhadFnRT0IdofEbc66UxnJg5ONgsKj8J6FJRNOCG9PvkT57nXZw%3D%3D')

//           const formStr = `<form name="punchout_form" method="post" action="">
// <input type="hidden" name="app_id" value="2021003173611913">
// <input type="hidden" name="biz_content" value="%7B%22out_trade_no%22%3A%222010053882%22%2C%22product_code%22%3A%22QUICK_WAP_PAY%22%2C%22subject%22%3A%22%5Cu68a6%5Cu5883%5Cu4fa6%5Cu63a2VIP%5Cu652f%5Cu4ed8%22%2C%22total_amount%22%3A%220.01%22%7D">
// <input type="hidden" name="charset" value="utf-8">
// <input type="hidden" name="method" value="alipay.trade.wap.pay">
// <input type="hidden" name="notify_url" value="https%3A//payment-cn-sandbox.ifunplus.cn/return/alipay2016">
// <input type="hidden" name="quit_url" value="https%3A//vip-sandbox.campfiregames.cn/game%3Ftype%3Dquit%26game_id%3D20125">
// <input type="hidden" name="return_url" value="https%3A//vip-sandbox.campfiregames.cn/game%3Fgame_id%3D20125">
// <input type="hidden" name="sign_type" value="RSA2">
// <input type="hidden" name="timestamp" value="2023-02-13%2012%3A37%3A14">
// <input type="hidden" name="version" value="1.0">
// <input type="hidden" name="sign" value="CT5TUiRT9cDYuHJH6UI9qD1HMNlOVhSDi5NVRdE0caHsnKMmC/nfibKmrvInVywUYPvEZhbqB8ja3U0wmkrML0rOGuSmxmldlbqFKTJLv8lUtBrGjNMv8Z6PQ%2BP%2BVpDOGMqBy3LAzpMP%2BIq31DdcUe37//PVRv91fZh7jBrs2THgneTvlul6O0dkmiSxn3KNGJ0Q4djBSk5LFD34CMJ8R4MeQttKDjguKrjHfN/HEOzd77T1PKLpwbDS/AgVznBm65EhiGM7i2aXa9kcnXmABwLjOIBS3cUIHS/YhadFnRT0IdofEbc66UxnJg5ONgsKj8J6FJRNOCG9PvkT57nXZw%3D%3D">
// <input type="submit" value="立即支付" style="display:none" >
// </form>`

          // await axios({
          //   method: 'POST',
          //   headers: {
          //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          //   },
          //   data: formData,
          //   url: 'https://openapi.alipay.com/gateway.do?charset=UTF-8'
          // })
          // app_id=2021003127625386&biz_content=%7B%22out_trade_no%22%3A%222000006952%22%2C%22product_code%22%3A%22FAST_INSTANT_TRADE_PAY%22%2C%22subject%22%3A%22%5Cu68a6%5Cu5883%5Cu4fa6%5Cu63a2VIP%5Cu652f%5Cu4ed8%22%2C%22total_amount%22%3A%220.01%22%7D&charset=utf-8&method=alipay.trade.page.pay&notify_url=https%3A//payment-cn-sandbox.ifunplus.cn/return/alipay2016&sign_type=RSA2&timestamp=2023-02-09%2018%3A53%3A49&version=1.0&sign=IRBloIs1CX86MaPJE27ezSjznGPbzew81LghisVKExq%2BHXbYuLj05uz99tNZqRECWA3zVYPXubbPmFfSvwjLT%2BR8JNWpuXRdJhkpcZVZ%2BkG0UCroyp7RmG%2Bo7saTFUPExwshTaVjsXlJCi0usAwv9pOUh/1hZnCFaEPJY5O5DkNUvb65Dvank/Z3P%2BTSXX1KLk1N/WN0LX0uJCVBEqvu93ZdC/PsdLCg21wOs%2B3%2BEZNoSHgfiPreka8l2IKQP2M7LggX2DWjMvoZtbWtPkmBXRbNsccNJo7KRn2N3Qco6i5z95%2BFio6mm1b5v2q/TqxmPL/HoDUpK9nNil4NN5gX/w%3D%3D
          const oDiv = document.createElement('div');
          oDiv.id = 'aipay_container'
          oDiv.innerHTML = formStr
          oDiv.style.position = 'absolute'
          oDiv.style.top = '-999999px'
          oDiv.style.left = '-999999px'
          document.body.appendChild(oDiv)
          const form = document.querySelector('#aipay_container form')
          // form.setAttribute('target', '_blank'); // 新开窗口跳转
          form.submit()
        } else {
          this.$parent.failpay("Order failed！");
        }
      },
      // 查询支付结果
      async checkOrderStatus() {
        try {
          const res = await getReservationOrder(this.payinfo)
          if(res.data.code == 1){
            // 支付成功
            this.$parent.successpay(response.data.data)
          } else {
            setTimeout(() => {
              this.checkOrderStatus()
            }, 2000)
          }
        } catch (error) {
          setTimeout(() => {
            this.checkOrderStatus()
          }, 2000)
        }
      }
    }
  }
</script>

<style scoped>
  #dropin{
    text-align: center;
  }
  .payitem{
    width: 90%;
    background-color: #FFFFFF;
    margin: 0 auto;
    padding: 3%;
    max-height: 90%;
    overflow-y: auto;
    position: relative;
    margin-top: 1.25rem;
  }
  .loadmask{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    padding-top: 3.75rem;
    top: 0;
    left: 0;
  }
  .loadmask p{
    color: #FFFFFF;
    font-size: 0.875rem;
    text-align: center;
  }
  .paytitle p{
    font-size:1rem;
    line-height:1.875rem;
    margin-bottom: 0.625rem;
    text-align: center;
  }
  .payhead{
    font-family: "SemiBold";
  }
  .loadimg{
    height: 12.5rem;
  }
  .close{
    width: 1.875rem;
    height: 1.875rem;
    display: block;
    float: right;
    margin: 0.625rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/wechat.vue